/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/

import PropTypes from 'prop-types';
import React from 'react';
import './style.css';

export const Link = ({ text = 'Link ', className, onClick = () => {} }) => {
    return (
        <div
            className={`link ${className}`}
            style={{ cursor: 'pointer' }}
            onClick={() => {
                onClick();
            }}
        >
            <div className="text-wrapper">{text}</div>
            <div className="rectangle" />
        </div>
    );
};

Link.propTypes = {
    text: PropTypes.string,
};
